/**
 * The configuration file for the general replacements upgrading to Angular 15.
 */

export const srcTsConfigLibProdReplaces = {
    '"enableIvy": false': '"compilationMode": "partial"'
};

export const versionJsonReplaces = {
    '"version":  "2.31.0"' : '"version":  "4.0.0"'
}
